import { alpha } from '@mui/material/styles';

export function todayTR() {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Istanbul',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date());
}

export function formatBandRange(band) {
  const min = band?.min_score;
  const max = band?.max_score;
  if (min === null || min === undefined) {
    if (max === null || max === undefined) return '—';
    return `0–${Number(max)}`;
  }
  if (max === null || max === undefined) return `${Number(min)}+`;
  return `${Number(min)}–${Number(max)}`;
}

export function normalizeSortOrder(value) {
  if (value === null || value === undefined || value === '') return Number.POSITIVE_INFINITY;
  const n = Number(value);
  return Number.isFinite(n) ? n : Number.POSITIVE_INFINITY;
}

export function bandTone(label) {
  const s = String(label || '').toLocaleLowerCase('tr-TR');
  if (s.includes('geliştir')) return 'warning';
  if (s.includes('orta')) return 'info';
  if (s.includes('iyi')) return 'success';
  return 'default';
}

export function bandChipSx(tone) {
  if (!tone || tone === 'default') return { fontWeight: 600 };
  return (theme) => {
    const main = theme.palette[tone]?.main || theme.palette.primary.main;
    const dark = theme.palette[tone]?.dark || theme.palette.text.primary;
    return {
      fontWeight: 700,
      borderColor: alpha(main, 0.45),
      bgcolor: alpha(main, 0.12),
      color: dark,
    };
  };
}
